export default __webpack_public_path__ + "static/media/logo.49e3181d.png";